import { useStrapi4 } from "#imports";
export const useStrapi = () => {
  return useStrapi4();
};
